import datePicker from './template/fields/date/datePicker.vue';
import Base from './base.js';
import Vue from 'vue';
import jQuery from 'jquery';

let defaultOptions = {
    dateInput: void 0,
    date: void 0,
    chooseDate: void 0,
    type: void 0
};

export default class DatePicker extends Base {

    constructor(options) {
        super();
        this.initialize(options, defaultOptions).init();
    }

    createModel() {
        let _this = this, $dateInput = jQuery(this.options.dateInput.$el).children('input');
        let position = {
            position: 'absolute',
            top: $dateInput.offset().top + $dateInput.outerHeight() + 6
        };

        let model = new Vue({
            el: jQuery('<date-picker :options="options"/>').appendTo('body')[0],
            components: { datePicker },
            data() {
                return {
                    options: _this.options
                }
            }
        });

        if ($dateInput.offset().left + jQuery(model.$el).width() < document.body.clientWidth) {
            position.left = $dateInput.offset().left;
        } else {
            position.right = 8;
        }
        let $dom = jQuery(model.$el).css(position);

        if ($dom.outerHeight() + $dom.offset().top > jQuery(window).height()) {
            $dom.addClass('top').css({
                top: $dateInput.offset().top - $dom.outerHeight() - 8
            });
        }
        return model;
    }

    destroy() {
        this.model.$children[0].destroy();
    }


    init() {
        if (!this.options.date) {
            this.options.date = new Date();
        }
        this.model = this.createModel();
        this.bindInstance(this.model.$el);
    }
}

